import React from 'react';
import './Footer.css';

/**
 * Footer.js - 하단 푸터 컴포넌트
 * 
 * 주요 구성:
 * 1. 좌측: 회사 로고 및 대표 전화번호
 * 2. 중앙: 회사 상세 정보 (대표자, 사업자번호, 주소 등)
 * 3. 우측: 공식 홈페이지 링크 및 카피라이트
 * 
 * @param {Object} props
 * @param {string} props.variant - 푸터 스타일 변형 ('default': 회색 배경, 'white': 흰색 배경)
 */
const Footer = ({ variant = 'default' }) => {
  return (
    <footer className={`footer-container ${variant === 'white' ? 'footer-white' : ''}`}>
      <div className="footer-content">
        {/* [좌측] 로고 및 연락처 영역 */}
        <div className="footer-left">
          <div className="footer-logo">
            <img
              src="/images/top_logo.png"
              alt="NEWONE"
              className="footer-logo-img"
            />
          </div>
          <div className="footer-contact">
            <span>📞 031-298-1191</span>
          </div>
        </div>

        {/* [중앙] 회사 사업자 정보 영역 */}
        <div className="footer-center">
          <div className="footer-info">
            <span>공동대표이사 : 이율범, 조청오</span>
            <span className="footer-divider">|</span>
            <span>사업자등록번호 : 124-87-01984</span>
          </div>
          {/* 본사 및 공장 주소 정보 */}
          <div className="footer-info">
            <span>본사 : 경기도 화성시 효행구 융건로 84-25. Tel: 031-298-1191 Fax: 031-297-4460</span>
          </div>
        </div>

        {/* [우측] 외부 링크 및 카피라이트 */}
        <div className="footer-right">
          <a
            href="https://www.newonetotal.co.kr"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-link"
          >
            공식 홈페이지 →
          </a>
          <div className="footer-copyright">
            © 2025 NEWONE
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
